
import {
  Modal,
  FormRow,
  Loader,
  Select
} from '@here/ref-client-ui';
import {MultiSelectDropdown} from './MultiSelectDropdown';
import { useMemo,useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSupportedCountries } from '../../state/countries';

const EditUserModal = ({ 
  isOpen, 
  isShown,
  onClose, 
  user, 
  onUserChange, 
  onSave, 
  isLoading,
  roleOptions,
  countryOptions
}) => {

const countries = useSelector(state => getSupportedCountries(state));

const countryDefaultOptions = useMemo(() => {
    return countries.map(country => ({
      value: country.code,
      label: country.name
    }));
}, [countries]);

const [selectedOptions, setSelectedOptions] = useState([]);


  useEffect(() => {
    if (Array.isArray(countryOptions) && countryOptions.length > 0) {
      const selectedList = countryOptions.map((option) => option.value || option.code);
      setSelectedOptions(selectedList);
    } else {
      setSelectedOptions([]);
    }
  }, [countryOptions]);

  if (!isOpen ) return null;

  const handleInputChange = (field, value) => {
    onUserChange(field, value);
  };

  const handleCheckboxChange = (optionValue) => {
    const updatedOptions = selectedOptions.includes(optionValue)
      ? selectedOptions.filter((val) => val !== optionValue)
      : [...selectedOptions, optionValue];
    setSelectedOptions(updatedOptions);
    handleInputChange('countries', updatedOptions);
  };

  // Handle "Select All"
  const handleSelectAll = () => {
    const allValues = countryDefaultOptions.map((option) => option.value);
    setSelectedOptions(
      selectedOptions.length === countryDefaultOptions.length ? [] : allValues
    );
    handleInputChange('countries',
      selectedOptions.length === countryDefaultOptions.length ? [] : allValues
    );
  };


  return (
    <div className="admin-modal">
      <Modal
        isOpen={isOpen}
        isShown={isShown}
        onClose={onClose}
        size="medium"
        title=""
      >
        <div className="admin-edit-modal">
            {
                user.updatedBy && (
                <div className='admin-user-updated-info'> 
                    <div>
                        UpdatedBy: {user.updatedBy}
                        <br /> {user.updatedOn ? `UpdatedOn: ${new Date(user.updatedOn).toLocaleString()}` : ''}
                    </div>
                </div>
                )
            }
          <div className='admin-modal-content'>

                <FormRow>
                    <div className="admin-display-field">
                    Name: { `${user.firstname} ${user.lastname}` || 'No name provided'}
                    </div>
                </FormRow>

                <FormRow className="admin-special-margin">
                    <div className="admin-display-field">
                    Email: { user.email || 'No name provided'}
                    </div>
                </FormRow>
                
                <FormRow label="Role" className="admin-special-margin role-option">
                    <Select
                    label="Roles: "
                    value={user.roles[0].trim().toUpperCase().replace(/\s/g, '')}
                    onChange={(e) => handleInputChange('roles', e.target.value)}
                    options={roleOptions}
                    />
                </FormRow>

                {
                   user.roles[0] === 'ADMIN' &&

                    <>
                    <FormRow >
                      <div className="admin-display-field">
                      <div className="admin-selected-countries-label">Selected Countries: </div> 
                      <div className="admin-selected-countries-list">
                          { countryDefaultOptions.filter(option => selectedOptions.includes(option.value)).map(option => option.label).join(', ') || 'No countries selected'}
                          </div>
                      </div>
                  </FormRow>

                
                  <FormRow label="Country">
                      <MultiSelectDropdown
                          options={countryDefaultOptions}
                          label="Countries:"
                          value={countryOptions || []}
                          onChange={(selected) => handleInputChange('countries', selected)}
                          selectedOptions={selectedOptions}
                          handleCheckboxChange={handleCheckboxChange}
                          handleSelectAll={handleSelectAll}
                      />
                  </FormRow>
                  </>
                }

                { user.roles[0] === 'SUPERADMIN' &&
                    <FormRow>
                      <div className="admin-display-field super-admin-note" >
                          * No need to select the countries for Super Admins as they have access to all supported countries.
                      </div>
                    </FormRow>
                }
                { user.roles[0] === 'USER' &&
                    <FormRow>
                      <div className="admin-display-field super-admin-note" >
                          * No need to select the countries for User role as they don't have edit access to any supported countries.
                      </div>
                    </FormRow>
                }
          </div>

          <div className="admin-modal-actions">
            <lui-button
              variant="secondary"
              onClick={onClose}
              {...(isLoading && {disabled: true})}
               class='reset-btn'
               title="Cancel"
            >
              ✕ Cancel Editing
            </lui-button>
            <lui-button
              variant="primary"
              onClick={onSave}
              {...(isLoading && {disabled: true})}
              class='submit-btn'
              title="Save"
              size="small"
            >
              {isLoading ? <Loader size="small" /> : '✓ Update User Details'}
            </lui-button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditUserModal;
